export default __webpack_public_path__ + "static/media/02.47df360f.jpg";